import React from 'react';
import { BarDatum, BarTooltipComponent } from '@nivo/bar';

import Bar from '~components/visualisation/bar/Bar';

export interface StackedBarProps {
  data: readonly BarDatum[];
  keys: string[];
  colors?: (props: { id: string | number }) => string;
  legendTitle?: string;
  axisLeftLegend?: string;
  valueFormatter?: (value: number) => string;
  maxValue?: number;
  minValue?: number;
  tooltip?: BarTooltipComponent<any> | undefined;
}

const StackedBar: React.FC<StackedBarProps> = ({
  data,
  keys,
  colors,
  legendTitle = '',
  axisLeftLegend = '',
  valueFormatter = (v) => v.toString(),
  tooltip,
}) => {
  return (
    <Bar
      data={data}
      keys={keys}
      indexBy="metric"
      responsive={true}
      enableLabel={false}
      groupMode="stacked"
      colors={colors}
      margin={{ top: 20, right: 30, bottom: 40, left: 60 }}
      axisBottom={{
        legend: legendTitle,
        legendPosition: 'middle',
        legendOffset: 20,
        tickSize: 0,
        tickPadding: 8,
      }}
      axisLeft={{
        legend: axisLeftLegend,
        legendPosition: 'middle',
        legendOffset: -50,
        tickSize: 0,
        tickPadding: 8,
        format: valueFormatter,
      }}
      tooltip={tooltip}
    />
  );
};

export default StackedBar;
